var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacher-list"},[_c('table-list',{attrs:{"title":"学员列表","loading":_vm.loading,"search-form":_vm.searchForm,"data":_vm.customerList,"columns":_vm.columns(this),"operates":_vm.operates(this),"pager":_vm.pager},on:{"search":_vm.onSearch,"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }